import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { getCrmHeatmap } from "../../api";
import { useAnalyticsFetch } from "./hooks/useAnalyticsFetch";
import HeatmapGrid from "./components/HeatmapGrid";

const DIMENSION_OPTIONS = [
  { value: "hour", label: "Hour of Day" },
  { value: "day_of_week", label: "Day of Week" },
  { value: "month", label: "Month" },
];

const METRIC_OPTIONS = [
  { value: "orders", label: "Orders" },
  { value: "revenue", label: "Revenue" },
];

const Heatmap = ({ filter, startDate, endDate }) => {
  const [dimension, setDimension] = useState("hour");
  const [metric, setMetric] = useState("orders");

  const { data, loading } = useAnalyticsFetch(getCrmHeatmap, [
    filter,
    startDate,
    endDate,
    dimension,
    metric,
  ]);

  return (
    <Container sx={{ paddingLeft: "0 !important", paddingRight: "0 !important" }}>
      <Box sx={{ display: "flex", gap: "1rem", marginBottom: "1rem", flexWrap: "wrap" }}>
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel id="heatmap-dimension-label">Dimension</InputLabel>
          <Select
            labelId="heatmap-dimension-label"
            label="Dimension"
            value={dimension}
            onChange={(event) => setDimension(event.target.value)}
          >
            {DIMENSION_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="heatmap-metric-label">Metric</InputLabel>
          <Select
            labelId="heatmap-metric-label"
            label="Metric"
            value={metric}
            onChange={(event) => setMetric(event.target.value)}
          >
            {METRIC_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <HeatmapGrid
        title="Order Heatmap"
        labels={data?.heatmap?.labels || []}
        series={data?.heatmap?.series || []}
        loading={loading}
      />
    </Container>
  );
};

Heatmap.propTypes = {
  filter: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default Heatmap;
